/* -*- coding: utf-8 -*-
 *
 * This file is part of ecosolutions.
 * Copyright (C) 2026 eco IT GmbH.
 *
 * Ecoitsolutions can not be copied and/or distributed without the express
 * permission of eco IT GmbH.
 */

// Front-office behaviour for the htu-share (Verleih) module.
//
// Progressive enhancement only: every list/filter/wizard form still works
// without JavaScript (explicit "Search"/"Apply"/"Continue" buttons submit
// it). This bundle is loaded on every Verleih page via
// ``htu_share/verleih/verleih_base.html`` and depends on ``htu-app-theme``
// so the shared Webpack runtime is not loaded twice.
(function () {
  "use strict";

  function initAutoSubmit() {
    const controls = document.querySelectorAll("[data-verleih-autosubmit]");
    controls.forEach(function (control) {
      control.addEventListener("change", function () {
        if (control.form) {
          control.form.submit();
        }
      });
    });
  }

  // Lending date+time slots use a date input and a quarter-hour <select>
  // that write a combined ``YYYY-MM-DDTHH:MM`` value into a hidden field.
  const STEP_MINUTES = 15;

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function parseLocal(localValue) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(localValue || "");
    if (!match) {
      return null;
    }
    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5])
    );
  }

  function formatLocal(dt) {
    return (
      dt.getFullYear() +
      "-" +
      pad(dt.getMonth() + 1) +
      "-" +
      pad(dt.getDate()) +
      "T" +
      pad(dt.getHours()) +
      ":" +
      pad(dt.getMinutes())
    );
  }

  function nextSlotAfter(localValue) {
    const dt = parseLocal(localValue);
    if (!dt) {
      return localValue;
    }
    dt.setMinutes(dt.getMinutes() + STEP_MINUTES);
    return formatLocal(dt);
  }

  function slotRoot(hidden) {
    return hidden.closest("[data-verleih-slot]");
  }

  function writeSlotHidden(slot) {
    const date = slot.querySelector("[data-verleih-slot-date]");
    const time = slot.querySelector("[data-verleih-slot-time]");
    const hidden = slot.querySelector("input[type='hidden']");
    if (!date || !time || !hidden) {
      return;
    }
    hidden.value = date.value && time.value ? date.value + "T" + time.value : "";
  }

  function clearSlot(slot) {
    const date = slot.querySelector("[data-verleih-slot-date]");
    const time = slot.querySelector("[data-verleih-slot-time]");
    const hidden = slot.querySelector("input[type='hidden']");
    if (date) {
      date.value = "";
    }
    if (time) {
      time.value = "";
    }
    if (hidden) {
      hidden.value = "";
    }
  }

  function setSlotDisabled(slot, disabled) {
    slot.querySelectorAll("[data-verleih-slot-date], [data-verleih-slot-time]").forEach(
      function (control) {
        control.disabled = disabled;
        // End slot is required only while it is usable.
        control.required = !disabled;
      }
    );
    if (disabled) {
      slot.setAttribute("aria-disabled", "true");
    } else {
      slot.removeAttribute("aria-disabled");
    }
  }

  function syncLendingDateRange(startHidden, endHidden) {
    const endSlot = slotRoot(endHidden);
    const baseMin = endHidden.getAttribute("data-verleih-base-min") || "";
    const startVal = startHidden.value;
    if (!startVal) {
      clearSlot(endSlot);
      setSlotDisabled(endSlot, true);
      endHidden.min = baseMin;
      return;
    }
    const minEnd = nextSlotAfter(startVal);
    setSlotDisabled(endSlot, false);
    endHidden.min = minEnd;
    const endDate = endSlot.querySelector("[data-verleih-slot-date]");
    if (endDate && minEnd.length >= 10) {
      endDate.min = minEnd.slice(0, 10);
    }
    if (endHidden.value && endHidden.value < minEnd) {
      clearSlot(endSlot);
    }
  }

  function initLendingDateRanges() {
    document.querySelectorAll("[data-verleih-range-start]").forEach(function (start) {
      const form = start.form || start.closest("form");
      if (!form) {
        return;
      }
      const end = form.querySelector("[data-verleih-range-end]");
      const startSlot = slotRoot(start);
      const endSlot = end ? slotRoot(end) : null;
      if (!end || !startSlot || !endSlot) {
        return;
      }
      if (!end.getAttribute("data-verleih-base-min")) {
        end.setAttribute("data-verleih-base-min", end.getAttribute("min") || "");
      }

      function onStartChange() {
        writeSlotHidden(startSlot);
        syncLendingDateRange(start, end);
      }

      function onEndChange() {
        writeSlotHidden(endSlot);
        syncLendingDateRange(start, end);
      }

      startSlot
        .querySelectorAll("[data-verleih-slot-date], [data-verleih-slot-time]")
        .forEach(function (control) {
          control.addEventListener("change", onStartChange);
        });
      endSlot
        .querySelectorAll("[data-verleih-slot-date], [data-verleih-slot-time]")
        .forEach(function (control) {
          control.addEventListener("change", onEndChange);
        });

      form.addEventListener("submit", function () {
        writeSlotHidden(startSlot);
        writeSlotHidden(endSlot);
      });

      writeSlotHidden(startSlot);
      writeSlotHidden(endSlot);
      syncLendingDateRange(start, end);
    });
  }

  function initSelectAllAndMaxOut() {
    const buttons = document.querySelectorAll("[data-verleih-select-all-items]");
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        const form = button.closest("form");
        if (!form) {
          return;
        }
        form.querySelectorAll("[data-verleih-item-row]").forEach(function (row) {
          const checkbox = row.querySelector('input[type="checkbox"]');
          const count = row.querySelector('input[type="number"]');
          if (checkbox) {
            checkbox.checked = true;
          }
          if (count && count.max) {
            count.value = count.max;
          }
        });
      });
    });
  }

  function boot() {
    initAutoSubmit();
    initLendingDateRanges();
    initSelectAllAndMaxOut();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
